import { DefaultConfigProps } from 'types'

export const drawerWidth = 280

export const awsconfig = {
  Auth: {
    oauth: {
      domain: 'auth.' + process.env.REACT_APP_ROOT_DOMAIN,
    },
    identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
    region: 'eu-west-1',
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_CLIENT_ID,
    mandatorySignIn: true,
    localStorage: {
      domain: 'app.' + process.env.REACT_APP_ROOT_DOMAIN,
      path: '/',
      expires: 365,
      secure: true,
    },
  },
}

export const awsconfiglocal = {
  Auth: {
    identityPoolId: 'eu-west-1:3f05d190-d35e-4b55-96de-d20f659a9069',
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_lnUI8hiO3',
    userPoolWebClientId: '5jsevrk02uqn0d7haomsaoro7r',
    localStorage: {
      domain: 'localhost',
      path: '/',
      expires: 365,
      secure: true,
    },
  },
}

// ==============================|| THEME CONFIG  ||============================== //

const config: DefaultConfigProps = {
  defaultPath: '/reports/overview',
  workspace: '',
  currency: '',
  timezone: '',
  fontFamily: `'Inter', sans-serif`,
  i18n: 'en',
  miniDrawer: false,
  drawerOpen: false,
  sampleData: false,
  attr: 'first',
  container: true,
  mode: 'light',
  presetColor: 'default',
  themeDirection: 'ltr',
  startDate: '',
  endDate: '',
  column: {
    ads: [
      'Spend',
      'Impressions',
      'Visitors',
      'Leads',
      'CPA (Leads)',
      'Orders',
      'CPA (Orders)',
      'Sales',
      'ROAS',
    ],
    channels: [
      'Visitors',
      'Form Submits',
      'Leads',
      'Orders',
      'Sales',
      'Ad spend',
      'ROAS',
    ],
    pages: [
      'Visitors',
      'Leads',
      'Orders',
      'Sales'
    ],
    organic: [
      'Visitors',
      'Leads',
      'Orders',
      'Sales',
    ]
  }
}

export default config
